const ValidityPeriodMaxMonth = 2;

export default ValidityPeriodMaxMonth;



// WEBPACK FOOTER //
// ./src/constants/validity-period-max-month.js